// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"user_confirmButton__d_PzN","cancelButton":"user_cancelButton__3WkjL","loading":"user_loading__28INY"};